export { default as default } from './FullPageLoader';
